import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "suggestions"]
    static values = {
        domains: {
            type: Array,
            default: ["gmail.com", "hotmail.com", "icloud.com", "outlook.com", "yahoo.com"]
        }
    }

    connect() {
        this.createSuggestionsContainer()
    }

    createSuggestionsContainer() {
        const suggestionsDiv = document.createElement("div")
        // Use Tailwind's 'hidden' class to ensure it's truly invisible when not in use
        suggestionsDiv.classList.add("email-suggestions", "hidden")
        suggestionsDiv.setAttribute("data-email-suggestions-target", "suggestions")
        
        // Inline styles for positioning and look
        suggestionsDiv.style.position = "absolute"
        suggestionsDiv.style.width = "100%" // Fixed width to match input
        suggestionsDiv.style.zIndex = "999999"
        suggestionsDiv.style.backgroundColor = "#000"
        suggestionsDiv.style.border = "1px solid #6c757d"
        suggestionsDiv.style.borderWidth = "0px" // Start with no border to avoid rogue lines
        suggestionsDiv.style.borderRadius = "12px"
        suggestionsDiv.style.marginTop = "4px"
        suggestionsDiv.style.textAlign = "left"
        suggestionsDiv.style.overflow = "hidden"
        suggestionsDiv.style.boxShadow = "0 10px 15px -3px rgb(0 0 0 / 0.1)"
        
        this.inputTarget.parentElement.style.position = "relative"
        this.inputTarget.parentElement.appendChild(suggestionsDiv)
    }

    handleInput(event) {
        const input = event.target.value
        const atIndex = input.lastIndexOf("@")

        if (atIndex !== -1) {
            const prefix = input.slice(0, atIndex + 1)
            const domainPrefix = input.slice(atIndex + 1).toLowerCase()

            if (!input.includes(".", atIndex)) {
                this.showFilteredSuggestions(prefix, domainPrefix)
            } else {
                this.hideSuggestions()
            }
        } else {
            this.hideSuggestions()
        }
    }

    showFilteredSuggestions(prefix, domainPrefix) {
        const filteredDomains = this.domainsValue.filter(domain =>
            domain.toLowerCase().startsWith(domainPrefix)
        )

        if (filteredDomains.length === 0) {
            this.hideSuggestions()
            return
        }

        this.suggestionsTarget.innerHTML = ""
        this.suggestionsTarget.classList.remove("hidden")
        this.suggestionsTarget.style.borderWidth = "1px" // Only show border when there are suggestions

        filteredDomains.forEach(domain => {
            const suggestion = document.createElement("div")
            suggestion.classList.add("suggestion-item", "p-3", "text-sm")
            suggestion.style.cursor = "pointer"
            suggestion.style.color = "#fff"
            suggestion.style.transition = "background-color 0.2s"
            suggestion.style.textAlign = "left"
            suggestion.textContent = prefix + domain
            
            suggestion.addEventListener("mouseenter", () => {
                suggestion.style.backgroundColor = "#2c3034"
            })
            suggestion.addEventListener("mouseleave", () => {
                suggestion.style.backgroundColor = "transparent"
            })
            suggestion.addEventListener("click", () => this.selectSuggestion(prefix + domain))
            this.suggestionsTarget.appendChild(suggestion)
        })
    }

    selectSuggestion(email) {
        this.inputTarget.value = email
        this.hideSuggestions()
    }

    hideSuggestions() {
        this.suggestionsTarget.classList.add("hidden")
        this.suggestionsTarget.style.borderWidth = "0px" // Hide border when cleaning up
    }

    // Hide suggestions when clicking outside
    clickOutside(event) {
        if (!this.element.contains(event.target)) {
            this.hideSuggestions()
        }
    }
}
